import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'benefits-form-stepper-card',
  templateUrl: './form-stepper-card.component.html',
  styleUrls: ['./form-stepper-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormStepperCardComponent {
  @Input() headerText = '';

  @Input() backButtonText = 'Back';

  @Input() nextButtonText = 'Next';

  @Input() disableBack = false;

  @Input() disableNext = false;

  @Input() loading = false;

  /**
   * Only show the next button, which will be put at the bottom right edge of the card.
   */
  @Input() onlyShowNext: boolean | undefined = true;

  @Output() backClick = new EventEmitter();

  @Output() nextClick = new EventEmitter();
}
